import classNames from 'classnames';
import {
  Field2 as Field,
  SidePanelSection,
} from 'vibeguide';
import C from 'constants';

function InformationFields({
  className,
  style,
  name = null,
  dealId = null,
  opportunityName = null,
  opportunityId = null,
  extReferenceId = null,
  onChange = () => {},
}) {
  return (
    <SidePanelSection
      className={classNames('InformationFields', className)}
      style={style}
      title={`${C.PROPOSAL} Information`}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
        }}
      >
        {name !== null && (
          <Field
            type="text"
            name="name"
            label={`${C.PROPOSAL} Name`}
            placeholder="Name"
            value={name}
            tabIndex={50}
            testId="flight-name-input"
            onChange={onChange}
            required
          />
        )}

        {dealId !== null && (
          <Field
            type="text"
            label="Deal ID"
            name="dealId"
            placeholder="Deal ID"
            value={dealId}
            tabIndex={51}
            testId="flight-deal-id-input"
            onChange={onChange}
            required
          />
        )}

        {opportunityName !== null && (
          <Field
            type="text"
            label="Opportunity Name"
            name="opportunityName"
            placeholder="Opportunity Name"
            value={opportunityName}
            tabIndex={52}
            testId="flight-opportunity-name-input"
            onChange={onChange}
          />
        )}

        {opportunityId !== null && (
          <Field
            type="text"
            label="Opportunity Salesforce ID"
            name="opportunityId"
            placeholder="Opportunity Salesforce ID"
            value={opportunityId}
            tabIndex={53}
            testId="flight-opportunity-id-input"
            onChange={onChange}
          />
        )}

        {extReferenceId !== null && (
          <Field
            type="text"
            label="Order Reference ID"
            name="extReferenceId"
            placeholder="Order Reference ID"
            value={extReferenceId}
            tabIndex={54}
            testId="flight-ext-reference-id-input"
            onChange={onChange}
          />
        )}
      </div>
    </SidePanelSection>
  );
}

export default InformationFields;
